<template>
  <blank-view>
    <div slot="action">
      <a-button
        type="primary"
        style="margin-right:8px"
        @click="showCreate = true"
        v-acl="'page_bill_classify_add'"
      >{{this.$t("create")}}</a-button>
      <a-button
        type="danger"
        :disabled="!selectedRowKeys.length"
        @click="handleDelete"
        v-acl="'page_bill_classify_delete'"
      >{{this.$t("delete")}}</a-button>
    </div>
    <div style="width:100%;height:100%;display:flex;">
      <!-- <div style="width:292px;margin-right:8px;background:white;">123</div> -->
      <ml-table
        style="width:100%;background:white;"
        size="small"
        rowKey="id"
        :defaultExpandAllRows="true"
        :canChangeColWidth="true"
        :dataSource="dataSource"
        :columns="columns"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          getCheckboxProps: this.getCheckboxProps
        }"
        :chooseArr='selectedRowKeys'
        @cancelChooseArr='cancelChooseArr'
      ></ml-table>
        <!-- :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          getCheckboxProps: this.getCheckboxProps
        }" -->
      <a-modal
        :title="$t('edit')"
        :visible="showEdit"
        @cancel="showEdit = false"
        :extraStyle="{ paddingBottom: '50px' }"
      >
        <curd-form
          v-if="showEdit"
          ref="form1"
          :schema="schema"
          :defaultValue="editdata"
          :footer="null"
        />
        <div
          slot="footer"
        >
          <a-button style="margin-right:8px" @click="showEdit = false">{{this.$t("cancel")}}</a-button>
          <a-button type="primary" @click="handleEdit">{{this.$t("save")}}</a-button>
        </div>
      </a-modal>
    </div>
    <a-modal
      :title="$t('create')"
      :visible="showCreate"
      @cancel="showCreate = false"
      @ok="handleCreate"
    >
      <curd-form v-if="showCreate" ref="form" :schema="schema" :footer="null" />
    </a-modal>
  </blank-view>
</template>

<script>
import { TenantInitialFieldTypeServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import CurdForm from "@/components/BaseCurd/form";

const tiftsp = new TenantInitialFieldTypeServiceProxy();
const options = {
  retrieve: tiftsp.getInitialFieldTypelist.bind(tiftsp),
  create: tiftsp.saveInitialFieldType.bind(tiftsp),
  update: tiftsp.editInitialFieldType.bind(tiftsp),
  delete: tiftsp.deleteInitialFieldType.bind(tiftsp),
};
export default {
  components: {
    "curd-form": CurdForm,
  },
  computed: {
    schema() {
      return {
        title: {
          type: "input",
          label: this.$t("page_bill_classify_name"),
          rules: [
            {
              required: true,
              message: this.$t("page_bill_classify_name_required"),
            },
          ],
          placeholder: this.$t('common_please_input') +  this.$t("page_bill_classify_name"),
        },
        bizCode: {
          type: "input",
          label: this.$t("page_bill_classify_code"),
          rules: [
            {
              required: true,
              message: this.$t("page_bill_classify_code_required"),
            },
          ],
          placeholder: this.$t('common_please_input') + this.$t("page_bill_classify_code"),
        },
        type: {
          type: "select",
          label: this.$t("page_bill_classify_type"),
          options: this.covertClassifyTypeList(),
          rules: [
            {
              required: true,
              message: this.$t("page_bill_classify_type_required"),
            },
          ],
          placeholder: this.$t('please_select') + this.$t("page_bill_classify_type"),
        },
        remark: {
          type: "input",
          label: this.$t("page_bill_classify_remark"),
          placeholder: this.$t('common_please_input') + this.$t("page_bill_classify_remark"),
        },
      };
    },
    columns() {
      return [
        {
          title: this.$t("actions"),
          key: "action",
          fix: "left",
          width: 80,
          customRender: (text, record) => {
            return (
              record.id != 'none' &&
              <a
                disabled={
                  !this.$store.getters.buttons.includes(
                    "page_bill_classify_edit"
                  )
                }
                onClick={() => this.openEdit(record)}
              >
                {this.$t("edit")}
              </a>
            );
          },
        },
        {
          title: this.$t("page_bill_classify_name"),
          dataIndex: "t",
        },
        {
          title: this.$t("page_bill_classify_code"),
          dataIndex: "bizCode",
        },
        {
          title: this.$t("page_bill_classify_type"),
          dataIndex: "type",
          customRender: (text,record) => {
            if(text) {
              return this.classifyTypeList[text]
            }
          },
        },
        {
          title: this.$t("page_bill_classify_remark"),
          dataIndex: "remark",
        },
      ];
    },
  },
  data() {
    return {
      showCreate: false,
      showEdit: false,
      ...options,
      editdata: {},
      dataSource: [],
      selectedRowKeys: [],
      classifyTypeList: {
        1: this.$t("page_bill_classify_product"),
        2: this.$t("page_bill_classify_plan"),
        3: '物料'
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {

    // rowSelection() {
    //   return {
    //     this.selectedRowKeys,
    //     onChange: (selectedRowKeys: any) => {
    //       this.selectedRowKeys = selectedRowKeys
    //     },
    //     getCheckboxProps(record) {
    //       return ({
    //         style: {
    //           display: record.id ? 'block' : 'none'
    //         },
    //         props: {
    //           disabled: record.id ? false : true
    //         }
    //       })
    //     }
    //   }
    // },
    cancelChooseArr(val) {
      this.selectedRowKeys = [];
    },
    getCheckboxProps(record) {
      console.log(record,'rererererer')
      return ({
        style: {
          display: record.id !== 'none' ? 'block' : 'none'
        },
        props: {
          disabled: record.id !== 'none' ? false : true
        }
      })
    },
    covertClassifyTypeList () {
      const arr = []
      for(const key in this.classifyTypeList) {
        arr.push({
          label:  this.classifyTypeList[key],
          value: key
        })
      }
      return arr
    },
    async handleEdit() {
      const data = await this.$refs.form1.manualSubmit();
      await this.update(data);
      this.$message.success(this.$t("modify_success"));
      this.showEdit = false;
      this.getData();
    },
    async handleCreate() {
      const data = await this.$refs.form.manualSubmit();
      await this.create(data);
      this.$message.success(this.$t("create_success"));
      this.showCreate = false;
      this.getData();
    },
    async handleDelete() {
      await this.delete(this.selectedRowKeys);
      this.$message.success(this.$t("delete_success"));
      this.getData();
    },
    openEdit(data) {
      if (!this.showEdit) {
        this.editdata = data;
        this.showEdit = true;
        return;
      }

      const form = this.$refs.form1.form.getFieldsValue();
      const keys = Object.keys(form);
      let bool = true;
      for (let key of keys) {
        if (this.editdata[key] != form[key]) {
          bool = false;
          break;
        }
      }

      if (bool) {
        this.editdata = data;
        this.showEdit = true;
        return;
      }

      this.$confirm({
        title: this.$t("switch_tips_title"),
        content: this.$t("switch_tips_content"),
        onOk: () => {
          this.editdata = data;
          this.showEdit = true;
        },
        onCancel() {
          return;
        },
      });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    async getData() {
      const data = await this.retrieve();
      data.forEach((item) => {
        item.t = item.title;
      });
      this.dataSource = data;
      let dataLength = data.length;
      let copy = JSON.parse(JSON.stringify(data));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            id: 'none'
          }
          copy.push(obj)  
        }
      }
      this.dataSource = JSON.parse(JSON.stringify(copy));

    },
  },
};
</script>>
